import { useState } from 'react'
import { FiImage, FiPlus } from 'react-icons/fi'
import { parseImageUrl } from '../../utils/imageUrl'

export default function ImageUrlInput({ onAdd, disabled = false }) {
  const [value, setValue] = useState('')
  const [error, setError] = useState('')

  const handleAdd = () => {
    const parsed = parseImageUrl(value)
    if (!parsed.valid) {
      setError(parsed.message)
      return
    }
    onAdd(parsed)
    setValue('')
    setError('')
  }

  return (
    <div className="space-y-2">
      <div className="flex flex-col sm:flex-row gap-2">
        <div className="relative flex-1">
          <FiImage className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <input
            type="url"
            value={value}
            disabled={disabled}
            onChange={(event) => { setValue(event.target.value); if (error) setError('') }}
            onKeyDown={(event) => { if (event.key === 'Enter') { event.preventDefault(); handleAdd() } }}
            placeholder="Paste any external image URL"
            className="input-field w-full pl-9"
          />
        </div>
        <button type="button" onClick={handleAdd} disabled={disabled || !value.trim()} className="inline-flex items-center justify-center gap-2 px-3 py-2 border border-blue-200 text-blue-600 rounded hover:bg-blue-50 disabled:opacity-50">
          <FiPlus className="w-4 h-4" /> Add Image URL
        </button>
      </div>
      {error && <p className="text-xs text-red-600">{error}</p>}
    </div>
  )
}